<template>
  <div>
    <Loading :activeLoading="activeLoading"></Loading>
    <router-view></router-view>
  </div>
</template>

<script>
import Loading from "./components/Loading/Index";

export default {
  name: 'App',
  components: {Loading},
  computed: {
    activeLoading () {
      return this.$store.state.loading
    }
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
